<app-hero-carousel></app-hero-carousel>
 @if (renderHomeContent) {
<app-stats></app-stats>
<app-home-dataset></app-home-dataset>
<app-home-model></app-home-model>
<app-home-compute></app-home-compute>
<app-home-competitions></app-home-competitions>
<app-home-usecase></app-home-usecase>
<app-home-toolkits></app-home-toolkits>
<app-home-model-tryout></app-home-model-tryout>
<app-explore-by-sector></app-explore-by-sector>
<app-spotlight></app-spotlight>
<app-faq-section></app-faq-section>
<div class="background-container"></div>
}
<div class="help-button position-fixed">
  <div
    class="position-relative submenu"
    [ngClass]="isSubOptionOpen ? 'slide-in' : 'slide-out'"
  >
    <ul
      class="d-flex justify-content-center align-items-start flex-column gap-2 p-0"
    >
      <a
        class="text-decoration-none text-black bg-white"
        [routerLink]="['/', routes.home, routes.faqs]"
      >
        <li>FAQ</li>
      </a>

      <a
        class="text-decoration-none text-black bg-white"
        [routerLink]="['/', routes.home, routes.userManual]"
      >
        <li>User Manual</li>
      </a>
      <a
        class="text-decoration-none text-black bg-white"
        (click)="utilityService.onGrievanceClick($event)"
      >
        <li>Report Grievance</li>
      </a>
      <!-- <a class="text-decoration-none text-black bg-white" [routerLink]="['/', routes.home, routes.securityMeasures]">
        <li>Security Measures</li>
      </a> -->
    </ul>
  </div>

  <!-- <button
    class="btn btn-primary"
    [ngClass]="{ 'btn-secondary': isSubOptionOpen }"
    (click)="isSubOptionOpen = !isSubOptionOpen"
  >
    @if (!isSubOptionOpen) {
      <div class="d-flex justify-content-center align-content-center gap-2">
        <img src="images/question_mark.svg" alt="" />
        <span>Help</span>
      </div>
    } @else {
      Close
    }
  </button> -->
</div>
